var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.webhookId)?_c('div',{staticClass:"webhook-id"},[_c('div',[_c('div',[_c('svg-icon',{attrs:{"icon-class":'webhook-id'}})],1),_c('div',{staticClass:"webhook-id__id-container ellipsis"},[_vm._v(" ID #"),_c('CopyText',{attrs:{"label":_vm.ellipsisCenter(_vm.webhookId),"value":_vm.webhookId}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }